(function() {
  define('bazemont/admins/list',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontAdminsList', ['ngAnimate', 'ui.bootstrap']).component('bazemontAdminsList', {
      templateUrl: '/assets/javascripts/bazemont/admins/list.html',
      controller: [
        '$http', 'Admin', 'TlhConfirmModalService', 'TlhNotificationService', function($http, Admin, TlhConfirmModalService, TlhNotificationService) {
          var userHasSelectedCategory, userHasSelectedRole, vm;
          vm = this;
          vm.$onInit = function() {
            vm.orderBy = 'email';
            return vm.resetList();
          };
          vm.isAdmin = function(user) {
            var result, role, _i, _len, _ref;
            result = false;
            if (user && user.roles) {
              _ref = user.roles;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                role = _ref[_i];
                if (role.name === 'admin') {
                  result = true;
                  break;
                }
              }
            }
            return result;
          };
          vm.isCurrentUser = function(user) {
            return user && user.email === vm.currentUserEmail;
          };
          vm.isFirstAdmin = function(user) {
            return user && user.email === 'admin@bazemont.fr';
          };
          vm.printUserRole = function(user) {
            var result, role;
            result = '';
            role = vm.getUserRole(user);
            if (role) {
              result = role.label;
            }
            return result;
          };
          vm.getUserRole = function(user) {
            var role;
            role = null;
            if (user && user.roles && user.roles.length > 0) {
              role = user.roles[0];
            }
            return role;
          };
          vm.printUserCategory = function(user) {
            var result, userCategory;
            result = '';
            if (vm.isAdmin(user)) {
              result = '<i class="fa fa-asterisk"></i>';
            } else {
              userCategory = vm.getUserCategory(user);
              result = userCategory && userCategory.category ? userCategory.category.title : '-';
            }
            return result;
          };
          vm.getUserCategory = function(user) {
            var category, userCategories;
            category = null;
            if (user) {
              userCategories = vm.getUserCategories(user);
              if (userCategories && userCategories.length > 0) {
                category = userCategories[0];
              }
            }
            return category;
          };
          vm.getUserCategories = function(user) {
            var userCategories, userCategory, _i, _len, _ref;
            userCategories = [];
            if (user && vm.usersCategories) {
              _ref = vm.usersCategories;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                userCategory = _ref[_i];
                if (userCategory.user.id === user.id) {
                  userCategories.push(userCategory);
                }
              }
            }
            return userCategories;
          };
          vm.printUserPages = function(user) {
            var result, userPage, userPages, _i, _len;
            result = '';
            if (vm.isAdmin(user)) {
              result = '<i class="fa fa-asterisk"></i>';
            } else {
              userPages = vm.getUserPages(user, vm.usersPages);
              if (userPages.length > 0) {
                for (_i = 0, _len = userPages.length; _i < _len; _i++) {
                  userPage = userPages[_i];
                  if (result) {
                    result += ', ';
                  }
                  result += userPage.page.title;
                }
              } else {
                result = '-';
              }
            }
            return result;
          };
          vm.getUserPages = function(user) {
            var userPage, userPages, _i, _len, _ref;
            userPages = [];
            if (user && vm.usersPages) {
              _ref = vm.usersPages;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                userPage = _ref[_i];
                if (userPage.user.id === user.id) {
                  userPages.push(userPage);
                }
              }
            }
            return userPages;
          };
          vm.showUser = function(user) {
            return user && user.isActive && userHasSelectedRole(user) && userHasSelectedCategory(user);
          };
          userHasSelectedRole = function(user) {
            var userRole;
            userRole = vm.getUserRole(user);
            return !vm.selectedRole || userRole && userRole.id === vm.selectedRole.id;
          };
          userHasSelectedCategory = function(user) {
            var userCategory;
            userCategory = vm.getUserCategory(user);
            return !vm.selectedCategory || userCategory && userCategory.category && userCategory.category.id === vm.selectedCategory.id;
          };
          vm.deleteUser = function(user) {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer l\'utilisateur ' + user.name + ' ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                TlhNotificationService.info({
                  message: 'Suppression en cours...',
                  delay: false
                });
                return new Admin(user).$delete().then(function() {
                  user.isActive = false;
                  return TlhNotificationService.success({
                    message: 'Suppression terminée',
                    replaceMessage: true
                  });
                })["catch"](function(error) {
                  message = "La suppression a échoué :<br>";
                  message += error.data ? error.data : "Erreur inattendue lors de la suppression, veuillez contacter l'administrateur.";
                  TlhNotificationService.error({
                    message: message,
                    replaceMessage: true,
                    delay: false
                  });
                  return console.error(error);
                });
              }
            });
          };
          vm.resetList = function() {
            return Admin.get(function(result) {
              vm.admins = result.admins || [];
              vm.roles = result.roles;
              vm.categories = result.categories;
              vm.pages = result.pages;
              vm.usersCategories = result.usersCategories;
              vm.usersPages = result.usersPages;
              return vm.currentUserEmail = result.currentUserEmail;
            });
          };
          vm["export"] = function($event) {
            var categoryId, roleId;
            $event.stopPropagation();
            $event.preventDefault();
            roleId = vm.selectedRole ? vm.selectedRole.id : 0;
            categoryId = vm.selectedCategory ? vm.selectedCategory.id : 0;
            window.open('/admin/administrateurs/export/administrateurs.csv?roleId=' + roleId + '&categoryId=' + categoryId + '&order=' + vm.orderBy, '_blank', '');
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=list.js.map
;
